import { useState, useEffect, useContext } from 'react'
import { enqueueSnackbar } from 'notistack'
import _ from 'lodash'

import { List, ListItem, Typography, Button } from '@mui/material'
import EditIcon from '@mui/icons-material/Edit'
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined'
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined'

import { AppContext } from '/providers/app-context'
import { getClientDetails, saveClientMainContact } from '../../providers/clients-api'
import Item from './edit-item'

const ContactAdmin = () => {
  const { apiSource, apiKey, processing, setProcessing } = useContext(AppContext)

  const [editing, setEditing] = useState(false)
  const [contactClient, setContactClient] = useState()
  const [clientCopy, setClientCopy] = useState()
  const [nameError, setNameError] = useState("")
  const [emailError, setEmailError] = useState("")
  const [billingEmailError, setBillingEmailError] = useState("")
  const [validity, setValidity] = useState({ main_contact_name: true, main_contact_email: true, billing_email: true })
  const refreshContactClient = async () => {
    // Main-contact and billing details always belong to the parent account,
    // rather than the child client currently selected in the header.
    const result = await getClientDetails({ apiSource, apiKey, includeChildClientId: false })
    if (result.ok) {
      setContactClient(result.client)
      setClientCopy(_.cloneDeep(result.client))
    }
  }

  useEffect(() => {
    refreshContactClient()
  }, [apiSource, apiKey])

  useEffect(() => {
    if (clientCopy) {
      setNameError(validity.main_contact_name ? "" : "Contact name is required.")
      setEmailError(validity.main_contact_email ? "" : "Contact email address is required.")
      setBillingEmailError(validity.billing_email ? "" : "Billing email address is required.")
    }
  }, [validity])


  const setClientValue = (field, e) => {

    const isValid = e.target.validity.valid

    let v = _.clone(validity)
    v[field] = isValid
    setValidity(v)

    let c = _.clone(clientCopy)
    c[field] = e.target.value
    setClientCopy(c)
  }

  const edit = () => {
    setEditing(true)
    setClientCopy(_.clone(contactClient))
  }

  const save = async () => {
    setProcessing(true)
    enqueueSnackbar({ message: "Saving Contact Details", variant: 'light' })
    await saveClientMainContact({ apiSource, apiKey, client: clientCopy, includeChildClientId: false })
    // TODO Add error handling
    enqueueSnackbar({ message: "Contact Details Saved", variant: 'success' })
    setProcessing(false)

    setEditing(false)
    refreshContactClient()
  }

  return (

    <div className='flex w-full flex-col gap-5 p-5'>
        <div className='flex flex-col gap-5'>
          <Typography variant='h4'>
            <div className='flex flex-row gap-20'>
              <div>Main Contact</div>
              <Button variant="outlined" startIcon={<EditIcon />} onClick={() => edit()} disabled={processing || !contactClient} sx={{ display: editing ? 'none' : '' }}>Edit</Button>
            </div>
          </Typography>

          <List>

            <Item title="Name" client={contactClient} clientCopy={clientCopy} field="main_contact_name" change={setClientValue} editing={editing} format="text" required={true} error={!validity.main_contact_name} helperText={nameError} />
            <Item title="Email" client={contactClient} clientCopy={clientCopy} field="main_contact_email" change={setClientValue} editing={editing} format="email" required={true} error={!validity.main_contact_email} helperText={emailError} />
            <Item title="Phone" client={contactClient} clientCopy={clientCopy} field="main_contact_phone" change={setClientValue} editing={editing} format="phone" />
            <Item title="Billing contact email" client={contactClient} clientCopy={clientCopy} field="billing_email" change={setClientValue} editing={editing} format="email" required={true} error={!validity.billing_email} helperText={billingEmailError} />

            <ListItem sx={{ display: editing ? '' : 'none' }}>
              <div className='flex flex-row justify-between w-full'>
                <Button variant='outlined' startIcon={<CancelOutlinedIcon />} onClick={() => setEditing(false)}>Cancel</Button>
                <Button variant='contained' startIcon={<SaveOutlinedIcon />} onClick={save} disabled={!validity.main_contact_name || !validity.main_contact_email || !validity.billing_email}>Save</Button>
              </div>
            </ListItem>

          </List>
        </div>
    </div>
  )
}

export default ContactAdmin
